import React, { useEffect } from "react";
import {
  Settings,
  Edit2,
  Camera,
  MapPin,
  Briefcase,
  Calendar,
  MessageCircle,
  Heart,
  Share2,
  Users,
  Image,
  LinkIcon,
} from "lucide-react";
import { Link } from "react-router-dom";
import { fetchMyPosts } from "../../../features/postSlice";
import { useDispatch, useSelector } from "react-redux";
import Post from "./Post.jsx";
import { formatPostTime } from "../../../utils/formatTime.js";
import { profileInfo } from "../../../features/userSlice.js";
import avaterPlaceholder from "../../../assets/img/avater.png";
import API from "../../../utils/Api";

// --- Main Profile Component ---
const UserProfilePage = () => {
  const dispatch = useDispatch();
  // Dummy User Data
  // const user = {
  //   name: "Hobayer Golondaz",
  //   username: "HobayerDev",
  //   bio: "Full Stack Web Developer | React & Tailwind Enthusiast. Building the next generation of social apps.",
  //   followers: 1250,
  //   following: 340,
  //   posts: 45,
  //   location: "Dhaka, Bangladesh",
  //   job: "Software Engineer at TechCorp",
  //   joinedDate: "January 2023",
  //   website: "https://yourwebsite.com",
  //   avatarUrl: "https://scontent.fdac157-1.fna.fbcdn.net/v/t39.30808-1/253672659_1074265496713688_942943787334063895_n.jpg?stp=c345.223.1208.1208a_dst-jpg_s100x100&_nc_cat=107&ccb=1-7&_nc_sid=f67be1&_nc_ohc=Wxj1w-DlPxAAX9gHxQ2&_nc_ad=z-m&_nc_cid=0&_nc_ht=scontent.fdac157-1.fna&oh=00_AfDXQHD_v8HxiNuqpAMZppDgq_CTRfuhELjhXPe5U-c85g&oe=63C7A3EC"
  // };
  const { user } = useSelector((state) => state.user);

  // Dummy Post Data
  const userPosts = [
    {
      id: 1,
      content:
        "Finished the new messaging feature! Two-column layout with a sleek chat bubble design. Check out the latest commit!",
      time: "2 hours ago",
      likes: 85,
      comments: 12,
    },
    {
      id: 2,
      content:
        "Loving this clean, minimalist aesthetic for the app. Sometimes less is definitely more.",
      time: "1 day ago",
      likes: 150,
      comments: 20,
      imageUrl:
        "https://images.unsplash.com/photo-1542435503-921449b2c89f?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    },
    {
      id: 3,
      content: "Just landed in Dhaka! Excited to meet the team this week.",
      time: "3 days ago",
      likes: 45,
      comments: 5,
    },
  ];
  const { myPosts } = useSelector((state) => state.post);
  const apiBase = API.defaults.baseURL?.replace(/\/api\/?$/, "") || "";
  const resolveAvatar = (url) =>
    url ? (url.startsWith("http") ? url : `${apiBase}${url}`) : "";
  useEffect(() => {
    dispatch(fetchMyPosts(user));
    dispatch(profileInfo());
  }, [dispatch]);
  return (
    <div className="min-h-screen bg-gray-100 font-sans">
      {/* Main Profile Area: 3-Column Grid (md:grid-cols-4 lg:grid-cols-12) */}
      <div className="max-w-6xl mx-auto pt-6 pb-12 grid grid-cols-1 md:grid-cols-4 lg:grid-cols-12 gap-6 px-4 sm:px-6 lg:px-8">
        {/* === Column 1: Left Sidebar (Profile Info and Bio) === */}
        {/* On mobile, this will appear first. On desktop, it's the left sidebar. */}
        <div className="md:col-span-1 lg:col-span-4">
          {user && (
            <div className="sticky top-20">
              {/* Profile Summary Card */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-6">
                {/* Cover Photo & Avatar */}
                <div className="h-28 bg-indigo-500 relative">
                  <div className="w-24 h-24 rounded-full border-4 border-white overflow-hidden shadow-sm absolute -bottom-12 left-6">
                    <img
                      src={resolveAvatar(user.avatarUrl) || avaterPlaceholder}
                      alt={user?.name || "User"}
                      className="w-full h-full object-cover"
                    />
                  </div>

                  <button className="absolute bottom-3 right-3 p-1.5 bg-white text-indigo-600 rounded-full shadow-sm hover:bg-gray-100 transition">
                    <Camera size={18} />
                  </button>
                </div>

                <div className="p-6 pt-16">
                   
                    <h2 className="text-2xl font-bold text-gray-900">
                      {user.name || "Songzug User"}
                    </h2> 

                  {/* Username */}
                  {user?.username && (
                    <p className="text-md text-gray-500 mb-3">
                      @{user.username}
                    </p>
                  )}

                  {/* Action Buttons */}
                  <div className="flex space-x-2 mb-4">
                    <Link
                      to="/edit-profile"
                      className="flex-1 py-2 bg-indigo-600 text-white rounded-full font-semibold text-sm hover:bg-indigo-700 transition flex justify-center items-center"
                    >
                      <Edit2 size={16} className="mr-1" /> Edit Profile
                    </Link>
                    <Link
                      to="/chat"
                      className="p-2 border border-gray-300 rounded-full text-gray-700 hover:bg-gray-100 transition"
                    >
                      <MessageCircle size={20} />
                    </Link>
                  </div>

                  
                    <p className="text-gray-700 mb-5">{user.bio || "Bio not set"}</p>
                  

                  {/* Profile Details */}
                  <div className="space-y-2 text-gray-600 mb-5 border-t pt-4">
                    {/* Job */} 
                      <div className="flex items-center text-sm">
                        <Briefcase size={16} className="mr-2 text-indigo-500" />
                        {user.job ? user.job : "Job not set"}
                      </div> 
 
                      <div className="flex items-center text-sm">
                        <MapPin size={16} className="mr-2 text-indigo-500" />
                        {user.location ? user.location : "Location not set"}
                      </div> 

                    
                      <Link
                        to={user.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center text-sm text-indigo-600 hover:text-indigo-700 hover:underline"
                      >
                        <LinkIcon size={16} className="mr-2" />
                        {user.website ? user.website.replace("https://", "") : "no website"}
                      </Link>
                    
 
                      <div className="flex items-center text-sm">
                        <Calendar size={16} className="mr-2 text-indigo-500" />
                        Joined {user.joinedDate ? user.joinedDate : "not showed"}
                      </div>
                 
                  </div>

                
                </div>
              </div>
 
            </div>
          )}
        </div>

        {/* === Column 2: Center Feed (Posts) === */}
        <div className="md:col-span-3 lg:col-span-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">
            Recent Posts
          </h3>

          {/* Create Post Widget (Optional, can be added here) */}
          {/* ... (Widget code from TimelinePage if needed) ... */}

          {/* User's Post Feed List */}
          <div className="space-y-6">
            {/* Feed List */}
            {myPosts.map((post) => {
              const { timeAgo, fullDate } = formatPostTime(post.createdAt);

              return (
                <Post
                  key={post._id}
                  postId={post._id}
                  username={
                    post.author.name ? post.author.name : post.author.username
                  }
                  avatar={post.author.avatarUrl}
                  userId={post.author._id}
                  handle={fullDate} // full date in hover
                  time={timeAgo} // "2 hours ago"
                  content={post.content}
                  imageUrl={post.imageUrl}
                  likes={post.likes}
                  comments={post.comments}
                />
              );
            })}

            <div className="text-center text-gray-500 py-4">
              <button className="text-indigo-600 hover:text-indigo-700 font-medium">
                No more posts 
              </button>
            </div>
          </div>
        </div>

        {/* Note: The right sidebar (Column 3) is omitted here but can be added back by reducing the center column size (e.g., lg:col-span-6) and adding the content for lg:col-span-3. */}
      </div>
    </div>
  );
};

export default UserProfilePage;
